export class RepostCountModel {
    _id: string | undefined;
    count: number | undefined;
    postId: string | undefined;
    sourceId: string | undefined;
    sourceType: string | undefined;
    userIds: any[] | undefined;
}